export default "__VITE_ASSET__Dzhn$z$l__"